import { userConstants } from '../constants';
import { userService } from '../services';
import {
  alertActions,
  fileActions,
  documentActions,
  reportActions,
  homeActions
} from '.';
// import { history } from '../utils';

import { actions } from 'react-redux-form';

export const userActions = {
  login,
  //autologin,
  logout,
  switchToSubUser,
  switchToMain,
  getAll,
  changeUserRecentVersionState
};

function login(username, password) {
  return dispatch => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      user => {
        dispatch(success(user));
        // update the default Size for all grids
        const defaultSize = user.PortalUserSettings.pageItemCount || 20;
        dispatch(actions.change('fileSearch.Size', defaultSize));
        dispatch(actions.change('docSearch.Size', defaultSize));
        dispatch(actions.change('execReportSearch.Size', defaultSize));
        dispatch(actions.change('configReportSearch.Size', defaultSize));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout(history) {
  userService.logout(history);
  return { type: userConstants.LOGOUT };
}

function switchToSubUser(subUser, subUserToken) {
  return async dispatch => {
    userService.switchToSubUser(subUser, subUserToken);
    dispatch(homeActions.clearFilters());
    dispatch(fileActions.clearFiles());
    dispatch(documentActions.clearDocuments());
    dispatch(reportActions.clearReports());
    dispatch(applySwitch(subUser));
  };
  function applySwitch(subUser) {
    return { type: userConstants.SWITCH_SUB, subUser };
  }
}

function switchToMain() {
  userService.switchToMain();
  return { type: userConstants.SWITCH_MAIN };
}

function changeUserRecentVersionState(userRecentVersion) {
  return { type: userConstants.SET_USER_RECENT_VERSION, userRecentVersion };
}

function getAll() {
  return dispatch => {
    dispatch(request());

    userService
      .getAll()
      .then(
        users => dispatch(success(users)),
        error => dispatch(failure(error))
      );
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}
